<template>
    <div class="productList" ref="container">
        <form @submit.prevent="submitForm">
            <div class="search bg-color-red acea-row row-between-wrapper">
                <div class="input acea-row row-between-wrapper">
                    <span class="iconfont icon-sousuo"></span>
                    <input placeholder="搜索商品信息" v-model="where.keyword" />
                </div>
                <div class="iconfont" :class="Switch === true ? 'icon-pailie' : 'icon-tupianpailie'" @click="switchTap">
                </div>
            </div>
        </form>

        <div class="wrapper module-shop-sort">
            <div class="wrapper wrapper-sort">
                <div class="nav-sort-top">
                    <div class="nav-sort-top-alone" v-for="(item, ind) in fastList" :key="ind"
                        @click="changeClassification(ind, item)">
                        <div class="nav-img" :class="calssName == ind ? 'nav-calss' : ''">
                            <img v-lazy="item.pic" />
                        </div>
                        <div class="nav-name" :class="calssName == ind ? 'nav-name-calss' : ''">{{ item.cate_name }}</div>
                    </div>
                </div>
            </div>
            <div class="nav-sort-top paginationshop">
                <div v-for="(item, ind) in shopNavList" :key="ind" class="paginationslot" @click="threeLevel(ind, item)"
                    :class="threeClss == ind ? 'threeClss' : ''">{{ item.cate_name }}
                </div>
            </div>
        </div>


        <div class="list acea-row row-between-wrapper" :class="Switch === true ? '' : 'on'" ref="container">
            <div @click="goDetail(item)" v-for="(item, index) in productList" :key="index" class="item"
                :class="Switch === true ? '' : 'on'" :title="item.store_name">
                <div class="pictrue" :class="Switch === true ? '' : 'on'">
                    <img :src="item.image" :class="Switch === true ? '' : 'on'" />
                    <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'"
                        v-if="item.activity && item.activity.type === '1'">秒杀</span>
                    <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'"
                        v-if="item.activity && item.activity.type === '2'">砍价</span>
                    <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'"
                        v-if="item.activity && item.activity.type === '3'">拼团</span>
                </div>
                <div class="text" :class="Switch === true ? '' : 'on'">
                    <div class="name line1">{{ item.store_name }}</div>
                    <div class="book_author" v-if="item.author">{{ item.author }}</div>
                    <div class="money font-color-red" :class="Switch === true ? '' : 'on'">
                        <span class="num">{{ item.price }}</span>
                    </div>
                    <div class="vip acea-row row-between-wrapper" :class="Switch === true ? '' : 'on'">

                    </div>
                </div>
            </div>
        </div>
        <div v-if="loadend && productList.length !== 0" class="page-text-center over-tip">已加载完成</div>
        <Loading :loaded="loadend" :loading="loading"></Loading>
        <div class="noCommodity" v-cloak style="background-color: #fff;" v-if="productList.length === 0 && where.page > 1">
            <div class="noPictrue">
                <img src="@assets/images/noGood.png" class="image" />
            </div>
        </div>
        <Recommend v-if="productList.length === 0 && where.page > 1" :type="where.type"></Recommend>
    </div>
</template>
  
<script>
import Recommend from "@components/Recommend";
import { getProducts, categoryLifeFirst, categoryLifeSecond, categoryLifeThreeProduct } from "@api/store";
import debounce from "lodash.debounce";
import Loading from "@components/Loading";
import { goShopDetail } from "@libs/order";
import Bus from "../../utils/eventBus";
export default {
    name: "GoodsList",
    components: {
        Recommend,
        Loading
    },
    props: {},
    data: function () {
        const { s = "", id = 0, title = "", hierarchy = false, type = 1, Switch = true } = this.$route.query;

        return {
            hostProduct: [],
            productList: [],
            fastList: [],
            shopNavList: [],
            Switch: Switch == "false" ? false : true,
            where: {
                id: 0,
                page: 1,
                limit: 8,
                navId:0,
                keyword: '',
            },
            title: title && id ? title : "",
            loadTitle: "",
            loading: false,
            loadend: false,
            price: 0,
            stock: 0,
            time: 0, //出版时间
            nows: false,
            scrollY: null,
            calssName: 0,//一级分类样式切换
            threeClss: 0,//二级分类样式切换
            shopListId:'',//请求列表分类的id
        };
    },
    watch: {
        title() {
            this.updateTitle();
        },
    },
    mounted: function () {
        this.updateTitle();
        this.categoryLifeFirst()
        this.get_product_list();
        this.$scroll(this.$refs.container, () => {
            !this.loading && this.get_product_list();
        }, this.scrollHander);
    },
    activated: function () {
        this.$nextTick(() => {
            window.scrollBy({ top: this.scrollY, left: 0 });
        })
    },
    methods: {
        scrollHander: function (e) {
            const scrollY = e.scrollY;
            this.scrollY = scrollY;
        },
        //请求分类列表
        categoryLifeFirst() {
            categoryLifeFirst().then(res => {
                this.fastList = res.data
            })
         this.where = {
                id: 0,
                page:1,
                limit: 8,
                navId:0,
            }
            categoryLifeSecond(this.where).then(res => {
                this.shopNavList = res.data.dataCate
            })
            // this.RequestGoodsList(this.where)
        },
        changeClassification(index, val) {
            this.calssName = index
            this.threeClss = 0
            this.shopListId=val.navId
            this.where = {
                id: 0,
                page: 2,
                limit: 8,
                navId:val.navId
            }
            let data={
                id: 0,
                page: 1,
                limit: 8,
                navId:val.navId
            }
            categoryLifeSecond(data).then(res => {
                this.shopNavList = res.data.dataCate
            })
            this.RequestGoodsList(data)
        },
        threeLevel(index, item) {
            this.threeClss = index;
            this.where = {
                id: item.id,
                page: 2,
                limit: 8,
                navId:this.shopListId,
            }
            let data={
                id: item.id,
                page: 1,
                limit: 8,
                navId:this.shopListId
            }
           this.RequestGoodsList(data)
        },

        //请求列表
        RequestGoodsList:debounce(function(data){
            
            this.loading=true
            categoryLifeThreeProduct(data).then(res => {
                this.loading=false
                this.productList = res.data.dataProduct
            })
        }),
        // 商品详情跳转
        goDetail(item) {
            goShopDetail(item).then(() => {
                this.$router.push({ path: "/detail/" + item.id });
            });
        },
        updateTitle() {
            document.title = this.title || this.$route.meta.title;
        },
        get_product_list: debounce(function () {
            var that = this;
            if (that.loading) return; //阻止下次请求（false可以进行请求）；
            if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
            that.loading = true;
            // this.setWhere();
            let q = that.where;
            categoryLifeThreeProduct(q).then(res => {
                that.loading = false;
                that.productList.push.apply(that.productList, res.data.dataProduct);
                that.loadend = res.data.dataProduct.length < that.where.limit; //判断所有数据是否加载完成；
                that.where.page = that.where.page + 1;
            });
        }, 300),
        submitForm: function () {
            this.$set(this, "productList", []);
            this.where.page = 1;
            this.loadend = false;
            this.loading = false;
            this.get_product_list();
        },
        backrouter() {
            this.$router.push({ path: "/category" });
            Bus.$emit("gitId")
        },
        //点击事件处理
        backrouter() {
            this.$router.push({ path: "/category" });
            Bus.$emit("gitId")
        },
        set_where: function (index) {
            let that = this;
            switch (index) {
                case 0:
                    if (this.$route.query.type == 2) {
                        return that.$router.push({ path: "/bookCategory" });
                    }
                    return that.backrouter()
                case 1:
                    if (that.price === 0) that.price = 1;
                    else if (that.price === 1) that.price = 2;
                    else if (that.price === 2) that.price = 0;
                    that.stock = 0;
                    that.time = 0;
                    break;
                case 2:
                    if (that.stock === 0) that.stock = 1;
                    else if (that.stock === 1) that.stock = 2;
                    else if (that.stock === 2) that.stock = 0;
                    that.price = 0;
                    that.time = 0;
                    break;
                case 3:
                    that.nows = !that.nows;
                    break;
                case 4:
                    if (that.time === 0) that.time = 1;
                    else if (that.time === 1) that.time = 2;
                    else if (that.time === 2) that.time = 0;
                    that.price = 0;
                    that.stock = 0;
                    break;
                default:
                    break;
            }
            that.$set(that, "productList", []);
            that.where.page = 1;
            that.loadend = false;
            that.get_product_list();
        },
        //设置where条件
        switchTap: function () {
            let that = this;
            that.Switch = !that.Switch;
        }
    }
};
</script>
<style scoped>
.noCommodity {
    border-top: 3px solid #f5f5f5;
    padding-bottom: 1px;
}

.productList .nav .item {
    /* width: 33%; */
    flex: 1;
}

.over-tip {
    line-height: 1rem;
    color: #868686;
}

.book_author {
    font-size: 0.3rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #9F9F9F;
    margin-top: 0.2rem;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-box-pack: center;
    -webkit-box-align: center;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.module-shop-sort {
    margin-top: 1rem;
}

.wrapper-sort {
    margin: 0 .2rem;
    border-radius: .2rem;
    box-shadow: 0rem .1rem .1rem #f5f5f5;
}

.nav-sort-top {
    width: 100%;
    box-sizing: border-box;
    overflow-x: scroll;
    white-space: nowrap;
    padding: .2rem;
    /* margin-top: .1rem; */
}

.nav-sort-top::-webkit-scrollbar {
    display: none;
}

.nav-sort-top-alone {
    width: 1.3rem;
    margin-right: .2rem;
    display: inline-block;
    text-align: center;
    overflow: hidden;
}

.nav-img {
    width: 1.2rem;
    height: 1.2rem;

}

.nav-calss {
    border-radius: .2rem .2rem .2rem .2rem;
    border: .02rem solid #9F9F9F;
}

.nav-name-calss {
    color: #F6433D;
}

.nav-sort-top-alone img {
    margin: .1rem auto;
    width: 1rem;
    height: 1rem;
    border-radius: .1rem;
}

.nav-name {
    text-align: center;
    line-height: .5rem;
}

.productList .list {
    margin-top: .28rem;
}

.paginationshop {
    height: .6rem;
    padding: 0 0.3rem;
    font-size: .3rem;
}

.paginationslot {
    min-width: 1.4rem;
    height: .6rem;
    border-radius: .3rem;
    text-align: center;
    background: #FFF;
    display: inline-block;
    margin-right: .3rem;
    line-height: .6rem;
    font-size: .3rem;
    color: #9F9F9F;
}

.paginationslot:last-child {
    margin-right: 0;
}

.threeClss {
    color: #F6433D;
    background: #FFE7E6;
}
</style>
  